import { useTranslation } from 'react-i18next';
import { Home, Phone, Users } from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent } from '../../ui/card';

export const WIZARD_STEPS = [
    'mriSafetyLeadership',
    'departmentSettings',
    'yourContacts',
] as const;

const STEP_ICONS: Record<(typeof WIZARD_STEPS)[number], React.ReactNode> = {
    mriSafetyLeadership: <Users className="h-4 w-4" />,
    departmentSettings: <Home className="h-4 w-4" />,
    yourContacts: <Phone className="h-4 w-4" />,
};

interface SetupIntroductionProps {
    onStart: () => void;
}

export default function SetupIntroduction({ onStart }: SetupIntroductionProps) {
    const { t } = useTranslation();

    return (
        <Card className="border-subtle bg-card">
            <CardContent className="px-6 py-6">
                <div className="space-y-3">
                    <h2 className="text-lg font-semibold">
                        {t('departmentVariables.setupIntro.title')}
                    </h2>
                    <p className="text-sm text-subtle-foreground font-medium leading-relaxed">
                        {t('departmentVariables.setupIntro.description')}
                    </p>
                </div>
                <div className="mt-5 grid gap-3 md:grid-cols-3">
                    {WIZARD_STEPS.map((step) => (
                        <div
                            key={step}
                            className="rounded-md border border-subtle bg-background px-3 py-3"
                        >
                            <div className="flex items-start gap-2">
                                <span className="mt-0.5 text-subtle-foreground">
                                    {STEP_ICONS[step]}
                                </span>
                                <div>
                                    <p className="text-sm font-medium text-foreground">
                                        {t(
                                            `departmentVariables.wizard.steps.${step}.title`
                                        )}
                                    </p>
                                    <p className="mt-1 text-xs text-subtle-foreground font-medium leading-relaxed">
                                        {t(
                                            `departmentVariables.wizard.steps.${step}.description`
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mt-5 flex justify-end">
                    <Button type="button" onClick={onStart}>
                        {t('departmentVariables.setupIntro.startSetup')}
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
}
